"use client";
import { Program } from "@/components/newIcons/Program";
import type { Countries } from "@/queries/getCountries";
import { SecondaryButton } from "ui/components";
import type { Departure } from "../../getDeparture";
import type { Travel } from "../../getTravel";
import { RequestProgram } from "../RequestProgram";
import { requestProgrammeOnSuccessServer } from "../RequestProgram/requestProgrammeOnSuccessServer";

type Props = {
  travel: Travel;
  departure: Departure;
  countries: Countries;
};
export const TopRequestProgram = ({ travel, departure, countries }: Props) => {
  return (
    <RequestProgram
      travelId={travel.id}
      isAvailable={departure.state.versionStatus !== "soon"}
      versionId={departure.versionId}
      departureId={departure.id}
      onSuccess={() => requestProgrammeOnSuccessServer(travel, departure)}
      countries={countries}
      travelTitle={travel.title}
      travelImage={travel.travelImages[0] || null}
      departure={departure}
      travelCountries={travel.countries}
      small
      source="before_program"
    >
      <SecondaryButton>
        <Program className="w-4 h-4" />
        Télécharger l'itinéraire complet
      </SecondaryButton>
    </RequestProgram>
  );
};
